import React from "react";
import { Toolbar, Box, Stack, Typography, Button } from "@mui/material";
import { useNavigate } from 'react-router-dom';
import HomeIcon from '@mui/icons-material/Home';

const NotFound = () => {
    const navigate = useNavigate();
    
    return (
        <Box sx={{ display: 'flex' }}>
            <Stack sx={{ flexGrow: 1, p: 3, maxWidth: '100%' }}>
                <Box>
                    <Toolbar />
                    <Box 
                        display="flex" 
                        flexDirection="column" 
                        justifyContent="center" 
                        alignItems="center"
                        sx={{ 
                            minHeight: '60vh',
                            animation: 'fadeIn 0.5s ease-in',
                            '@keyframes fadeIn': {
                                from: { opacity: 0 },
                                to: { opacity: 1 },
                            },
                        }}
                    >
                        <Typography 
                            variant="h1" 
                            sx={{ 
                                fontSize: { xs: '4rem', md: '6rem' },
                                fontWeight: 700,
                                background: 'linear-gradient(135deg, #1976d2 0%, #42a5f5 100%)',
                                WebkitBackgroundClip: 'text',
                                WebkitTextFillColor: 'transparent',
                                backgroundClip: 'text',
                                mb: 2,
                            }}
                        >
                            404
                        </Typography>
                        <Typography 
                            variant="h4" 
                            sx={{ 
                                fontWeight: 600,
                                mb: 2,
                                textAlign: 'center',
                            }}
                        >
                            Page Not Found
                        </Typography>
                        <Typography 
                            variant="body1" 
                            color="text.secondary"
                            sx={{ 
                                mb: 4,
                                textAlign: 'center',
                                maxWidth: '500px',
                            }}
                        >
                            The page you are looking for might have been removed, had its name changed, or is temporarily unavailable.
                        </Typography>
                        <Button 
                            variant="contained" 
                            color="primary"
                            startIcon={<HomeIcon />}
                            onClick={() => navigate('/app')}
                            sx={{
                                transition: 'all 0.2s ease-in-out',
                                '&:hover': {
                                    transform: 'translateY(-2px)',
                                    boxShadow: (theme) => theme.shadows[8],
                                },
                            }}
                        >
                            Go to Home
                        </Button>
                    </Box>
                </Box>
            </Stack>
        </Box>
    );
};

export default NotFound;